/**
 * Confirm Clock In/Out Modal Component
 * OEE-styled confirmation dialog for starting or ending a shift
 */

import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { DetailHeaderAction } from '../../../../../modules/shared/detail-page'

export interface ConfirmClockData {
    mode: 'clock-in' | 'clock-out'
    elapsed?: string
}

@Component({
    selector: 'app-confirm-clock-modal',
    templateUrl: './confirm-clock-modal.component.html',
    styleUrls: ['./confirm-clock-modal.component.scss'],
    standalone: false
})
export class ConfirmClockModalComponent {
    constructor(
        public dialogRef: MatDialogRef<ConfirmClockModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmClockData
    ) {}

    get isClockIn(): boolean {
        return this.data.mode === 'clock-in'
    }


    /** Footer actions rendered by `<app-detail-action-bar flavor="material">`. */
    get footerActions(): DetailHeaderAction[] {
        return [
            {
                id: 'cancel',
                label: 'Cancel',
                tone: 'secondary',
                align: 'start'
            },
            this.isClockIn
                ? {
                    id: 'confirm',
                    label: 'Clock In',
                    matIcon: 'login',
                    tone: 'success' as const
                }
                : {
                    id: 'confirm',
                    label: 'Clock Out',
                    matIcon: 'logout',
                    tone: 'danger' as const
                }
        ]
    }

    onFooterAction(a: DetailHeaderAction): void {
        if (a.id === 'cancel') this.onCancel()
        else if (a.id === 'confirm') this.onConfirm()
    }

    onCancel(): void {
        this.dialogRef.close(false)
    }

    onConfirm(): void {
        this.dialogRef.close(true)
    }
}
